import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  gap: 24px;
  padding-bottom: 48px;

  align-items: center;
`;
